import React, {useEffect, useMemo, useState} from 'react';
import {
    Alert,
    Container,
    Grid,
    Stack,
} from "@mui/material";
import axios from "../utils/axios";

import {FormProvider} from "../components/hook-form";
import {Form, FormControl, InputGroup} from "react-bootstrap";
import {CustomButton} from "../components";
import {useForm} from "react-hook-form";
import useIsMountedRef from "../hooks/useIsMountedRef";
import {Link, useNavigate} from "react-router-dom";
import {PATH_APP} from "../routes/paths";
import jMoment from "moment-jalaali";
import moment from 'jalali-moment'
import {toast} from "react-toastify";
import {Picker} from "react-mobile-style-picker";
import 'react-mobile-style-picker/dist/index.css'
import range from "../utils/range";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalali from "@date-io/date-fns-jalali";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import useAuth from "../hooks/useAuth";
import Header from "../components/header";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

jMoment.loadPersian({dialect: "persian-modern", usePersianDigits: true});

export default function Profile() {

    const {user, initialize} = useAuth()

    const [birthDate, setBirthDate] = useState(user?.birth_date);

    const navigate = useNavigate()

    const isMountedRef = useIsMountedRef();

    const [height, setHeight] = useState(user?.user_information?.height);

    let heightList = range(100, 200)

    const defaultValues = useMemo(
        () => ({
            full_name: user?.full_name || '',
            gender: user?.user_information.gender || '',
            marital_status: user?.user_information.marital_status || '',
            activity_severity: user?.user_information.activity_severity || ''
        }), [user]
    )

    const methods = useForm({
        defaultValues,
    });

    const {
        register,
        setError,
        handleSubmit,
        clearErrors,
        formState: {errors, isSubmitting},
    } = methods;

    const onSubmit = async (data) => {
        const formData = new FormData()
        formData.append("full_name", data.full_name)
        formData.append("birth_date", moment(birthDate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'))
        formData.append("mobile", user?.mobile)
        formData.append("height", height)
        formData.append("gender", data.gender)
        formData.append("activity_severity", data.activity_severity)
        formData.append("has_experience", data.has_experience === true ? 1 : 0)
        formData.append("marital_status", data.marital_status)
        formData.append("_method", "PUT")
        await axios.post("/update-profile", formData).then((response) => {
            navigate(PATH_APP.home)
            toast.success("پروفایل شما با موفقیت بروز شد.", {
                position: "bottom-left",
                autoClose: 5000,
                rtl: true,
            })
            initialize()
        }).catch((error) => {
            toast.error(error.errors.full_name[0], {
                position: "top-left",
                autoClose: 5000,
                rtl: true,
            })
        })
    };

    return (
        <div id="information-page">
            <Header header="white-header" link={PATH_APP.home} title="ویرایش پروفایل"/>
            <FormProvider noValidate methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Container style={{marginTop: "100px"}}>
                    <Stack>
                        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
                        <Grid className="custom-input" sx={{mb: 2}}>
                            <label className="fw-bold">نام و نام خانوادگی</label>
                            <InputGroup>
                                <FormControl type="text" name="full_name" placeholder="نام و نام خانوادگی ..." size="lg"
                                             {...register('full_name')}/>
                            </InputGroup>
                        </Grid>
                        <Grid className="custom-input" sx={{mb: 2}}>
                            <label className="fw-bold">تاریخ تولد</label>
                            <LocalizationProvider dateAdapter={AdapterJalali}>
                                <DatePicker
                                    mask="____/__/__"
                                    value={birthDate}
                                    label=" تاریخ تولد"
                                    openTo="year"
                                    closeOnSelect={true}
                                    inputFormat="yyyy/MM/dd"
                                    views={['year', 'month', 'day']}
                                    onChange={(newValue) => {
                                        setBirthDate(newValue);
                                    }} renderInput={({inputRef, inputProps, InputProps}) => (
                                    <InputGroup>
                                        <FormControl {...inputProps} type="text"
                                                     size="lg"/>
                                        {InputProps?.endAdornment}
                                    </InputGroup>
                                )}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid sx={{mb: 2}}>
                            <label className="fw-bold">وضعیت تاهل</label>
                            <InputGroup>
                                <Form.Select {...register('marital_status')} name="marital_status"
                                             aria-label="وضعیت تاهل">
                                    <option value="single" key={1}>مجرد</option>
                                    <option value="married" key={2}>متاهل</option>
                                </Form.Select>
                            </InputGroup>
                        </Grid>

                        <Grid sx={{mb: 2}}>
                            <label className="fw-bold">جنسیت</label>
                            <InputGroup>
                                <Form.Select {...register('gender')} name="gender" aria-label="جنسیت">
                                    <option value="male" key={1}>مرد</option>
                                    <option value="female" key={2}>زن</option>
                                </Form.Select>
                            </InputGroup>
                        </Grid>

                        <Grid sx={{mb: 2}}>
                            <label className="fw-bold">میزان فعالیت</label>
                            <InputGroup>
                                <Form.Select {...register('activity_severity')} name="activity_severity"
                                             aria-label="میزان فعالیت">
                                    <option value="seldom" key={1}>خیلی کم</option>
                                    <option value="low" key={2}>کم</option>
                                    <option value="medium" key={3}>متوسط</option>
                                    <option value="high" key={4}>زیاد</option>
                                    <option value="intense" key={5}>خیلی زیاد</option>
                                </Form.Select>
                            </InputGroup>
                        </Grid>

                        <div className="mt-4 user-information-footer">

                            <Form.Check {...register('has_experience')}
                                        type="switch"
                                        defaultChecked={user?.user_information?.has_experience}
                                        className="custom-switch"
                                        label="تجربه کاهش وزن داشته ام"
                            />
                        </div>

                        <div id="information-page" style={{marginBottom:"100px"}}>
                            <div className="height-box mb-4">
                                <div className="d-flex justify-content-between height-box-header">
                                    <h2>قد (سانتیمتر)</h2>
                                    <span>{height}</span>
                                </div>
                                <div className="swipe-picker-wrapper">
                                    <div className="swipe-picker" dir="ltr">
                                        <Picker mode="horizontal" value={height} smooth={true}
                                                onChange={(data) => {
                                                    setHeight(data)
                                                }}
                                                scrollSelect={true} dragSelect={true}
                                                clickSelect={true} size={5} rotate={false}>
                                            {
                                                heightList.map(function (value) {
                                                    return (<Picker.Item value={value}>{value}</Picker.Item>)
                                                })
                                            }
                                        </Picker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Stack>
                    <footer className="fixed-bottom">
                        <Container>
                            <Grid className="custom-input">
                                <CustomButton type="submit" loading={isSubmitting} onClick={() => clearErrors()}>
                                    <span>بروز رسانی</span>
                                </CustomButton>
                            </Grid>
                        </Container>
                    </footer>
                </Container>
            </FormProvider>
        </div>
    )
}